import { Gender } from '@/api-gen/api.schemas';
import avatarFlatFemale from '/avatar_flat_female.webp';
import avatarFlatMale from '/avatar_flat_male.webp';
import avatarPixarFemale from '/avatar_pixar_female.webp';
import avatarPixarMale from '/avatar_pixar_male.webp';

export const getGenderFromSex = (sex?: Gender | null): Gender => {
  if (sex === Gender.Male) {
    return Gender.Male;
  }

  return Gender.Female;
};

export const getPortrait = (type: 'flat' | 'pixar', gender?: Gender | null) => {
  const resolvedGender = gender === Gender.Male ? Gender.Male : Gender.Female;

  if (type === 'pixar') {
    return resolvedGender === Gender.Male ? avatarPixarMale : avatarPixarFemale;
  }

  return resolvedGender === Gender.Male ? avatarFlatMale : avatarFlatFemale;
};
